import React from 'react';
import { Skeleton } from '../ui/Skeleton';

export default function SkeletonSiteDetail() {
  return (
    <div className="px-8 py-8 max-w-6xl mx-auto animate-pulse">
      {/* Back link */}
      <Skeleton className="h-4 w-24 mb-6" rounded="rounded" />

      {/* Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <Skeleton className="h-7 w-48 mb-2" rounded="rounded" />
          <Skeleton className="h-4 w-36" rounded="rounded" />
        </div>
        <div className="flex gap-2">
          <Skeleton className="h-9 w-24" rounded="rounded-lg" />
          <Skeleton className="h-9 w-20" rounded="rounded-lg" />
        </div>
      </div>

      {/* Pages section */}
      <div className="mb-4 flex items-center justify-between">
        <Skeleton className="h-5 w-20" rounded="rounded" />
        <Skeleton className="h-8 w-24" rounded="rounded-lg" />
      </div>

      {/* Table header */}
      <div className="grid grid-cols-[1fr_140px_100px_44px] items-center px-4 pb-2 border-b border-gray-200 dark:border-gray-700">
        <Skeleton className="h-3 w-12" rounded="rounded" />
        <Skeleton className="h-3 w-20" rounded="rounded" />
        <Skeleton className="h-3 w-12" rounded="rounded" />
        <div />
      </div>

      {/* Table rows */}
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className="grid grid-cols-[1fr_140px_100px_44px] items-center px-4 py-3 border-b border-gray-100 dark:border-gray-700/50">
          <div className="flex items-center gap-3">
            <Skeleton className="w-5 h-5" rounded="rounded" />
            <Skeleton className="h-4 w-28" rounded="rounded" />
            {i === 0 && <Skeleton className="h-5 w-12" rounded="rounded-full" />}
          </div>
          <Skeleton className="h-3 w-20" rounded="rounded" />
          <Skeleton className="h-3 w-14" rounded="rounded" />
          <Skeleton className="h-6 w-6" rounded="rounded" />
        </div>
      ))}
    </div>
  );
}
